export default "__VITE_ASSET__CUXAr8mH__"